module.exports = __webpack_public_path__ + "img/strooigoed_anna_belt_terug-M.png";